import { TableUrlStateDirective } from './table-url-state.directive';
import { TablePaginationComponent } from './table-pagination.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '../../design/icons.module';
import { PaginationComponent } from './pagination.component';

@NgModule({
  declarations: [PaginationComponent, TablePaginationComponent, TableUrlStateDirective],
  imports: [CommonModule, IconsModule],
  exports: [PaginationComponent, TablePaginationComponent, TableUrlStateDirective]
})
export class PaginationModule { }
